export const ASSISTANT_ROLE = "Assistant";

export const ASSISTANT_HOME_PATH = "/dashboard/correct-student-exams";

/** Paths an Assistant may open. Reports plus Missed activity. */
export const ASSISTANT_ALLOWED_PATHS = [
  "/dashboard/missed-activity",
  "/dashboard/correct-student-exams",
  "/dashboard/exam-report-by-chapter",
  "/dashboard/payment-report",
  "/dashboard/unpaid-report",
  "/dashboard/attendence-report",
  "/dashboard/absent-report",
  "/dashboard/live-video-attendance-report",
  "/dashboard/live-video-absence-report",
  "/dashboard/detailed-exam-report",
  "/dashboard/exam-attendence-report",
  "/dashboard/attendence-simple-report",
  "/dashboard/manual-exam-marks-report",
  "/dashboard/print-all-questions",
];

export function readStoredRoleName() {
  try {
    return window.localStorage.getItem("user_role") || "";
  } catch {
    return "";
  }
}

export function roleNameFromUser(userData) {
  return userData?.role?.[0]?.name || readStoredRoleName();
}

export function isAssistantRole(userData) {
  return roleNameFromUser(userData) === ASSISTANT_ROLE;
}

export function isAssistantPathAllowed(pathname) {
  if (!pathname) return false;
  return ASSISTANT_ALLOWED_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`)
  );
}
